$( document ).ready(function() {  
  var selected_size;
  var selected_style;
  
  function selectedSIze(){
    var selected_size;
    $('.row-wrapper--size').find('.row-wrapper__item').each(function(){
      if($(this).find('button').hasClass('selected')){
        console.log('here');
          var select_size =  $(this).find('button').attr('data-val');
          selected_size = select_size;
      }  
    });
    return selected_size;
  }
  
  function selectedStyle(){
    var stylearray = [];
    $('.row-wrapper--style').find('.row-wrapper__item--style').each(function(){
    	var style = $(this).find('.step-selection-btn').attr('data-val');
      	console.log(style);
      	stylearray.push(style);
    });
    return stylearray;
  }
  
  function hideshow(step1,step2){
  	$(step1).hide().css('height','0');
    $(step2).show().css('height','auto');
  }
  
  function settargetvariant(){
    $('#builder-slider-amount .icon-wrapper__item.wrapper-item').show();
    var option1 = $('.step.step1').find('.selection-val').text();
    var option2 = $('.step.step2').find('.selection-val').text();
    $('.icon-wrapper__item.wrapper-item').each(function(){
      var tarele = $(this).find('select');
      tarele.find('option[data-size="'+option1+'"][data-style="'+option2+'"]').prop('selected', true);
    });
    //show hide product based on availability
    $('#builder-slider-amount .icon-wrapper__item.wrapper-item').each(function(){
      var product_item = $(this);
      var pinventory = parseInt(product_item.find('.select.product-option option[data-size="'+option1+'"][data-style="'+option2+'"]').attr('data-inv'));
      if(pinventory < 1){
        product_item.hide();
      }
    });
  }
  
  function checkstockcountwithstyle(){
  	var option1 = $('.step.step1').find('.selection-val').text();
    //now compare option1 vs all option2
    
	
    $('#builder-slider-style .row-wrapper__item').each(function(){
		var ele = $(this);
      	var option2 = ele.find('.btn.step-selection-btn').attr('data-val');
		//for each of 3 products does these option1 & option 2 is out of stock?
      	var instock = false;
      	$('#builder-slider-amount .icon-wrapper__item.wrapper-item').each(function(){
            var product_item = $(this);
            var pinventory = parseInt(product_item.find('.select.product-option option[data-size="'+option1+'"][data-style="'+option2+'"]').attr('data-inv'));
			// console.log(product_item.find('.icon-wrapper__content > span').html() + option1 + option2 + pinventory);
            if(pinventory >=1){
				instock = true;
            }
        });
        if(!instock){
          ele.addClass('soldout');
        }
	});
    
  }
  
  /* Size selection */
    $('#builder-slider-size button.step-selection-btn').on('click',function(e){
    	e.preventDefault();
      $('#builder-slider-size button.step-selection-btn').removeClass('selected');
      var getSelVal = jQuery(this).attr('data-val');
      var step = $('.step.step1');
      var seltext = ''+ getSelVal;
      step.find('.selection-val').html(seltext);
      step.removeClass('active').addClass('done');
      $(this).addClass('selected');
      //stock or out of stock check in next step
      checkstockcountwithstyle();
      //hideshow
      setTimeout(function(){
        $('#builder-slider-size').hide();
        $('#builder-slider-style').show().css('height','auto');
      },500);
    });
    
    /* Style selection */
    $('#builder-slider-style button.step-selection-btn').on('click',function(e){
      if(!$(this).parent().hasClass('soldout')){
    	e.preventDefault();
        $('#builder-slider-style button.step-selection-btn').parent().removeClass('selected');
        var getSelVal = jQuery(this).attr('data-val');      
        var step = $('.step.step2');
        var seltext = ''+ getSelVal;
        step.find('.selection-val').html(seltext);
        step.removeClass('active').addClass('done');
        $(this).parent().addClass('selected');
        //select the exact option on dropdown on next step
        settargetvariant();
        //hideshow
        setTimeout(function(){
          $('#builder-slider-style').hide();
          $('#builder-slider-amount').show().css('height','auto');
          if(getSelVal == "All 4 Pairs"){
            console.log(getSelVal);
            $('.icon-wrapper__item').each(function(){
              var producttitle = $(this).attr('data-product');
              if(producttitle != "Monthly Subscription - 4 Panties"){
                $(this).hide();
              }
            });	        
          }
        },500);
      }
    });
  
  /* Back buton */
  $('#builder-slider-style .btn.btn--previous').on('click',function(){
    $('#builder-slider-style .row-wrapper__item').removeClass('soldout').removeClass('selected');
  	hideshow('#builder-slider-style','#builder-slider-size');
  });
  $('#builder-slider-amount .btn.btn--previous').on('click',function(){
  	hideshow('#builder-slider-amount','#builder-slider-style');
  });
  $('#builder-slider-checkout .btn.btn--previous').on('click',function(){
	hideshow('#builder-slider-checkout','#builder-slider-amount');
  });
  
/*  
  $('.row-wrapper--size .step-selection-btn').on('click',function(){
    var select_size = $(this).attr('data-val');
    var styleArray = selectedStyle();
    $.each(styleArray, function( index, value ) {
      var selected_size = select_size;
      var selected_style = value;
      var hasvariant = false;
      $('.icon-wrapper--plan').find('.icon-wrapper__item').each(function(){  
        var $select = $(this).find('select > option');
        $select.each(function() {
          var variant_size = $(this).attr('data-size');
          var variant_style = $(this).attr('data-style');
          var variant_inventoryqty = parseInt($(this).attr('data-inv'));
          if(variant_size == selected_size &&  variant_style == selected_style && variant_inventoryqty > 0){  
            var selected_variant = $(this).val();
            var selected_variant_price = $(this).attr('data-price');            
            hasvariant = true;
          }
        });  

      });      
      if(!hasvariant){      
        $('.row-wrapper--style').find('.row-wrapper__item--style').each(function(){
          var style = $(this).find('.step-selection-btn').attr('data-val');
          console.log(style);
          if(style == selected_style){
          	$(this).addClass('soldout');
          }
        });
      } 

    });
  });
  
  $('.row-wrapper__item--style button').on('click',function(){
    var selected_size = selectedSIze();
    var selected_style = $(this).attr('data-val');        
    console.log(selected_size);
    $('.icon-wrapper--plan').find('.icon-wrapper__item').each(function(){      
    	var hasvariant = false;
    	var $select = $(this).find('select > option');
    	$select.each(function() {
          var variant_size = $(this).attr('data-size');
          var variant_style = $(this).attr('data-style');
          var variant_inventoryqty = parseInt($(this).attr('data-inv'));
          if(variant_size == selected_size &&  variant_style == selected_style && variant_inventoryqty > 0){    
            var selected_variant = $(this).val();
            var selected_variant_price = $(this).attr('data-price');
            $(this).parent().parent().parent().find('.cost-month').html(selected_variant_price + '/Month');
            $(this).parent().val(selected_variant);
            hasvariant = true;
          }
        });
      if(!hasvariant){      
      	$(this).hide();
      }
      
      
    });
  	
  });
*/
  

  
  
});


  